/** Dashboard report API (cross-module KPI aggregation). Returns raw (unwrapped). */

import { apiGet } from "@/lib/api-client";

export type DashboardPeriod = "month" | "3m" | "6m" | "1y";

/**
 * ADR-001 : mêmes tables et formules que la Vue d'ensemble compta.
 * `netProfitDzd` peut être NÉGATIF (une perte s'affiche, jamais masquée) ;
 * `treasury` est un record par devise (comptes actifs uniquement).
 */
export interface DashboardKpis {
  collectedDzd: number;
  expensesDzd: number;
  netProfitDzd: number;
  receivablesDzd: number;
  overdueInvoices: { count: number; value: number };
  treasury: Record<string, number>;
  adSpendUsd: number;
  walletBalanceUsd: number;
  lowWallets: number;
  clientsActive: number;
  pendingApprovals: number;
}

export interface DashboardReport {
  kpis: DashboardKpis;
  period: string;
}

export const dashboardApi = {
  get: (period: DashboardPeriod) => apiGet<DashboardReport>("/reports/dashboard", { period }),
};

export interface MonthlySeriesPoint {
  month: string;    // "YYYY-MM"
  revenue: number;  // DZD
  expenses: number; // DZD
  profit: number;   // DZD
  adSpend: number;  // USD
}

export const getMonthlySeries = (months: number) =>
  apiGet<{ series: MonthlySeriesPoint[] }>("/reports/monthly-series", { months });

export type ActivityItemType = "PAYMENT_RECEIVED" | "CLIENT_ADDED" | "AD_SPEND" | "WALLET_TOPUP";

export interface ActivityItem {
  type: ActivityItemType;
  id: string;
  clientId: string;
  clientName: string;
  amountDzd?: number;
  amountUsd?: number;
  occurredAt: string;
}

export const getRecentActivity = () =>
  apiGet<{ items: ActivityItem[] }>("/reports/recent-activity");
